/*
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by Rahul Bagaira <Rahul@wakencode.com>, 6 2023
 *
 */

import { fetchImageList} from "../images";
import { createSlice } from "@reduxjs/toolkit";
import { IImage } from "../../model/images";

const initialState: IImage = {
  imageListLoading: false,
  imageListData: {
    data: [],
  },
  imageListError: "",  
};

export const imageSlice = createSlice({
  name: "images",
  initialState,
  reducers: {},
  extraReducers: (Builder) => {    

    Builder.addCase(fetchImageList.pending, (state) => {
      return {
        ...state,
        imageListLoading: true,
      };
    })
      .addCase(fetchImageList.fulfilled, (state, action) => {
        return {
          ...state,
          imageListLoading: false,
          imageListData: action.payload,
        };
      })
      .addCase(fetchImageList.rejected, (state, action) => {
        return {
          ...state,
          imageListLoading: false,
          imageListError: action.payload || "OOPS! Internal server error",
        };
      });    
  },
});

export const imageReducer = imageSlice.reducer;
